import m from "mithril"
import { state } from "../state/store.js"

function closeMobileNav() {
  state.mobileNavOpen = false
  document.body.style.overflow = ""
}

export default {
  view: function () {
    return m("div.mobile-nav", {
      class: state.mobileNavOpen ? "open" : "",
    }, [
      m("a.mobile-nav-link.active", {
        href: "#portfolio",
        onclick: closeMobileNav,
      }, "Portfolio"),
      m("a.mobile-nav-link", {
        href: "#portfolioGrid",
        onclick: closeMobileNav,
      }, "Experiment"),
      m("a.mobile-nav-link", {
        href: "#contact",
        onclick: closeMobileNav,
      }, "Contact"),
    ])
  },
}
